import Link from "next/link";
import DownloadApp from "@svg/footer/download";
import GooglePlayAndroidIcon from "@svg/app/google-play-android";
import GooglePlayIcon from "@svg/app/google-play";
import { APP_REDIRECT_DOWNLOAD_URL } from "@utils/constants";
import ArrowIcon from "@svg/footer/arrow";
import DirectDownloadIcon from "@svg/footer/direct-download";
import AppLink from "./app-link";

const footerAppIcon = [
  {
    title: "دریافت نسخه اندروید",
    firstIcon: DirectDownloadIcon,
    secondIcon: <span className="title-md-medium">دانلود مستقیم</span>,
    link: APP_REDIRECT_DOWNLOAD_URL,
  },
  {
    title: " دریافت نسخه اندروید از",
    firstIcon: GooglePlayAndroidIcon,
    secondIcon: <GooglePlayIcon fill="#fff" />,
    link: "https://play.google.com/store/apps/details?id=org.faradars.app&utm_source=faradars.org&utm_campaign=app_dl_page&pli=1",
  },
];

const HomeAppsFooter: React.FC = () => {
  return (
    <div className=" bg-fds-canvas-secondary w-full">
      <div className="max-w-[1920px] mx-auto  flex flex-col lg:flex-row items-center justify-between py-5 w-full  px-6 md:px-16 lg:px-fds-120 xl:px-16 ">
        <div className="flex flex-row w-full items-center justify-between">
          <p className="font-medium  items-center text-base flex flex-row gap-2 text-[#202123] leading-6">
            <DownloadApp />
            دانلود اپلیکیشن فرادرس
          </p>
          <div className="flex items-center">
            <div className="lg:flex hidden   flex-row gap-4     items-center pl-10">
              {footerAppIcon.map((item, index) => (
                <AppLink id="first" item={item} key={index} />
              ))}
            </div>
            <Link
              href={"/app"}
              className="p-3  text-fds-icon-brand bg-fds-brand-light rounded-8"
            >
              <ArrowIcon className="h-6  w-6" />
            </Link>
          </div>
        </div>
        <div className=" flex mt-6   lg:hidden  flex-col gap-4     items-center w-full">
          {footerAppIcon.map((item, index) => (
            <AppLink id="second" item={item} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeAppsFooter;
